function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.217 6.924V2.032H7.54c.612 0 1.11.497 1.11 1.108v2.676c0 .61-.498 1.108-1.11 1.108H1.217zm8.621-1.125v-.25h1.816l-.872 1.718c-.082.169-.08.373.008.543l.844 1.61H8.167c-.575-.007-1.04-.476-1.04-1.048v-.25h.388c1.281 0 2.323-1.042 2.323-2.323zm-1.644 4.837h4.425c.213 0 .413-.114.523-.298.114-.181.13-.396.042-.585l-1.173-2.22 1.175-2.294c.114-.2.114-.431.006-.62-.116-.19-.329-.306-.557-.286h-2.84V3.14c0-1.281-1.042-2.324-2.323-2.324H1.23L1.217.579C1.201.254.931-.001.61-.001.6 0 .59 0 .58.002.242.018-.017.304 0 .64v13.737c0 .336.273.609.608.609.335 0 .608-.273.608-.61V8.123h4.721v.25c0 1.244 1.011 2.26 2.256 2.264z"
});

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "#919191",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag.ab59e3b0.svg";
export { ForwardRef as ReactComponent };